import moment from 'moment';

let gmtOffset = localStorage.getItem('betfair_app_prefered_offset') 
  ? localStorage.getItem('betfair_app_prefered_offset') 
  : parseInt( ( moment().format('Z') ).substr(1,2), 10);

let oddsFormat = localStorage.getItem('betfair_app_prefered_odds_format')
  ? localStorage.getItem('betfair_app_prefered_odds_format')
  : 'dec';

let currency = localStorage.getItem('betfair_app_currency')
  ? localStorage.getItem('betfair_app_currency')
  : 'EUR';

const initialState = {
  isLoading: false,
  isSettingsOpen: false,
  feedData: [],
  COMPS_CDN: 'https://wbsearthcomps-5c24.kxcdn.com/',
  TEAMS_CDN: 'https://www.europaleague.gr/betarades/cdn/teams/',
  FLAGS_EXT: '.png',
  sortFilter: '1x2',
  gmtOffset: gmtOffset,
  oddsFormat: oddsFormat,
  currency: currency,
  currencySymbols: {
    'EUR': '€',
    'GBP': '£',
    'USD': '$'
  },
  locale: 'el',
  feedOffset:60*60*1,
  feedDomainUrl: '',
  rates:{},
  textlink: '',
  clientDisabled: false
};

export default function AppReducer (state = initialState, action) {
  switch (action.type) {

    case 'FETCH_FEED_REQUEST':
    return {
      ...state,
      isLoading:true,
    }
    case 'FETCH_FEED_SUCCESS':{

      const {feedData} = action;
      return {
        ...state,
        isLoading:false,
        feedData
      }
    }
    case 'FETCH_FEED_ERROR':{
      const {error} = action;
      return {
        ...state,
        isLoading:false,
        error
      }
    }
    case 'SORT_FEED_DATA':{
      const {feedData} = action;
      return {
        ...state,
        feedData
      }
    }
    case 'SETTINGS_TOGGLE':{
      const {isSettingsOpen} = action;
      return {
        ...state,
        isSettingsOpen: !isSettingsOpen
      }
    }
    case 'UPDATE_SORT_FILTER': {
      const {sortFilter} = action;
      return {
        ...state,
        sortFilter
      }
    }
    case 'UPDATE_GMT_OFFSET': {
      const {gmtOffset} = action;
      return{
        ...state,
        gmtOffset
      }
    }
    case 'UPDATE_ODDS_FORMAT':{
      const {oddsFormat} = action;
      return {
        ...state,
        oddsFormat
      }
    }
    case 'UPDATE_CURRENCY':{
      const {currency} = action;
      return{
        ...state,
        currency
      }
    }
    case 'UPDATE_RATES':{
      const {rates} = action;
      return{
        ...state,
        rates
      }
    }
    case 'UPDATE_LOCALE':{
      const {locale} = action;
      return {
        ...state,
        locale
      }
    }
    case 'UPDATE_FEED_DOMAIN_URL':{
      const {feedDomainUrl} = action;
      return {
        ...state,
        feedDomainUrl
      }
    }
    case 'UPDATE_TEXTLINK':{
      const {textlink} = action;
      return {
        ...state,
        textlink
      }
    }
    case 'CLIENT_STATUS':{
      const {clientDisabled} = action;
      return {
        ...state,
        clientDisabled
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/reducers.js